<template>
  <div class="page-box">
    <Header />
    <QianchengContent />
    <Footer />
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import QianchengContent from './QianchengContent.vue'
export default {
  name: "qcSuper",
  components: {
    Header,
    Footer,
    QianchengContent
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped></style>
